import { cn } from "@/lib/utils";
import type { NormalizedEvent } from "@/services/types/agent-gateway";
import { Activity, Loader2 } from "lucide-react";
import { formatEventTime } from "./event-utils";

type StatusEvent = Extract<NormalizedEvent, { type: "agent_status" }>;

export function AgentStatus({ event }: { event: StatusEvent }) {
  const working = ["active", "running", "working"].includes(
    event.content.status.toLowerCase(),
  );
  const Icon = working ? Loader2 : Activity;

  return (
    <output className="flex min-w-0 flex-wrap items-center gap-3 rounded-lg bg-slate-100/80 px-4 py-3 text-slate-600 text-sm">
      <Icon
        aria-hidden="true"
        className={cn("size-4", working && "animate-spin")}
      />
      <span className="min-w-0 flex-1 [overflow-wrap:anywhere]">
        {event.content.label}
      </span>
      <time
        className="shrink-0 text-xs"
        dateTime={event.created_at ?? undefined}
      >
        {formatEventTime(event.created_at)}
      </time>
    </output>
  );
}
